import React, { useEffect, useState } from "react";
const FPS = 24;
const START = 12 * FPS;
export function Timecode({
  frozen
}: {
  frozen: boolean;
}) {
  const [frame, setFrame] = useState(START);
  useEffect(() => {
    if (frozen) return;
    const id = window.setInterval(() => setFrame(f => f + 1), 1000 / FPS);
    return () => window.clearInterval(id);
  }, [frozen]);
  return <span className="flex items-center gap-2 font-mono text-[10px] tracking-[0.12em] text-white/80 md:text-[11px]" data-id="element-266" data-mp="76ydj5vpikna">
      {frozen ? <span className="text-signal" data-id="element-267" data-mp="3al2je66q9kgs">❚❚ HELD</span> : <span className="flex items-center gap-1.5 text-signal" data-id="element-268" data-mp="3annkgsz7bwdh">
          <span className="rec-dot is-round inline-block h-1.5 w-1.5 bg-signal" aria-hidden="true" data-id="element-269" data-mp="3fjcg4l83ot4i" />
          PLAY
        </span>}
      <span className="tabular-nums" data-id="element-270" data-mp="uuomv6m1hc7s">TC {format(frame)}</span>
    </span>;
}
function format(total: number) {
  const ff = total % FPS;
  const s = Math.floor(total / FPS);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${pad(Math.floor(s / 3600))}:${pad(Math.floor(s / 60) % 60)}:${pad(s % 60)}:${pad(ff)}`;
}